// extracted by mini-css-extract-plugin
export var avatarBone = "_3-4";
export var buttonBone = "_3-3";
export var continueBone = "_3-a";
export var frame = "_3-1";
export var logoBone = "_3-2";
export var pickerGrid = "_3-d";
export var pitchBone = "_3-9";
export var productBone = "_3-8";
export var sectionBone = "_3-7";
export var shell = "_3-0";
export var skeletonPulse = "_3-b";
export var subtitleBone = "_3-6";
export var titleBone = "_3-5";
export var viewport = "_3-c";